import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Routes from "integrations/aws/common/Routes";
const AWSInputConfiguration = ({ url = Routes.INTEGRATIONS.AWS.CLOUDWATCH.index }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(url);
  }, [url, navigate]);
  return null;
};
export default AWSInputConfiguration;
